export default __webpack_public_path__ + "static/media/ELECTRIC SHOCK ACCIDENT SIMULATOR.e1f7f96c.JPG";